import { IBaseIconProps } from "./IBaseIconProps";

export const EnvelopeIcon = ({ color = "#000" }: IBaseIconProps) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15_17)">
        <path
          d="M3 17.5V6.5C3 5.94772 3.44772 5.5 4 5.5H12H20C20.5523 5.5 21 5.94772 21 6.5V17.5C21 18.0523 20.5523 18.5 20 18.5H4C3.44772 18.5 3 18.0523 3 17.5Z"
          stroke={color}
          strokeLinejoin="round"
        />
        <path d="M3 6L12 12L21 6" stroke={color} strokeLinejoin="round" />
      </g>
    </svg>
  );
};
